<template>
  <app-chart-wrapper class="card">
    <div class="card-header flex-space-between">
      <div>{{$t('message.statistics.message.screenTime')}}: {{screenTime
                }}s</div>
    </div>

    <h4 class="text-muted text-center my-4 white-space-normal">
      {{stats.description}}
    </h4>

    <div class="card-body">
      <div class="chart">
        <canvas ref="chart"></canvas>
      </div>

      <ul class="doughnut-footer">
        <li v-for="(label, index) in data.labels"
            :key="index"
            v-on:click="openModalAnswers(label)">

          <div>
            <div class="circle"
                 :style="{'border-color': color(index)}"></div>
          </div>

          <div class="label">
            {{label}}
          </div>

          <div class="text-right flex-justify-end">
            {{datasetItemValue(index)}}
          </div>

          <div class="text-sm text-right flex-justify-end"
               :style="{color: color(index)}">
            ({{percentage(datasetItemValue(index))}}%)
          </div>

        </li>

        <li>
          <div></div>
          <div class="label">
            <div>{{$t('message.statistics.message.engagement')}}:</div>
          </div>
          <div></div>
          <div class="text-sm text-right flex-justify-end">
            <div class="text-success">{{engagement}}%</div>
          </div>

        </li>
        <li>
          <div></div>
          <div class="label">
            <div>{{$t('message.statistics.message.rejection')}}:</div>
          </div>
          <div></div>
          <div class="text-sm text-right flex-justify-end">
            <div class="text-danger">{{rejection}}%</div>
          </div>

        </li>
      </ul>

    </div>
  </app-chart-wrapper>
</template>

<script>
import interactionStat from "./interaction-stat";
import Chart from "chart.js";
import colors from "@packages/colors";
import AppChartWrapper from "@components/chart/ChartWrapper";
import EventBus from "@packages/event-bus/index";
import _ from "lodash";

export default {
  mixins: [interactionStat],

  components: {
    AppChartWrapper,
  },

  data() {
    return {
      chartBackground: colors.charts.doughnut,
    };
  },
  computed: {
    total() {
      return _.sum(this.data.datasets[0].data);
    },
  },
  methods: {
    color(index) {
      return colors.charts.doughnut[index];
    },

    datasetItemValue(index) {
      if (!this.data.datasets) return;

      return this.data.datasets[0].data[index];
    },

    percentage(value) {
      return this.total !== 0 ? Math.round((value / this.total) * 100) : 0;
    },

    openModalAnswersFromChart(_event, element) {
      let dataAnswer = {
        mode: this.mode,
        interactionId: this.stats.interactionBody.id,
        advertisingId: this.stats.campaignId,
        answer: element[0]._model.label,
        answers: this.data.labels,
      };
      EventBus.$emit("OPEN_MODAL_ANSWERS", dataAnswer);
    },

    openModalAnswers(label) {
      let dataAnswer = {
        mode: this.mode,
        interactionId: this.stats.interactionBody.id,
        advertisingId: this.stats.campaignId,
        answer: label,
        answers: this.data.labels,
      };
      EventBus.$emit("OPEN_MODAL_ANSWERS", dataAnswer);
    },

    async buildChart() {
      if (this.chart) await this.chart.destroy();

      const options = {
        cutoutPercentage: 80,
        legend: {
          display: false,
        },
        onClick: this.openModalAnswersFromChart,
      };

      this.chart = await new Chart(this.$refs.chart, {
        type: "doughnut",
        data: this.data,
        options,
      });
    },
  },

  mounted() {
    this.buildChart();
  },
};
</script>

<style lang="scss" scoped>
.card {
  display: flex;
  flex-direction: column;

  .card-header {
    align-items: center;

    .repetition {
      display: flex;
      align-items: center;
      flex-grow: 0;
    }
  }

  .card-body {
    display: flex;
    align-items: center;
    flex-grow: 1;

    .chart {
      width: 40%;
    }

    & > *:last-child {
      flex-grow: 1;
    }
  }
}

li {
  width: 100%;
  display: grid;
  grid-template-columns: 30px 200px auto 40px;
  font-size: 16px;

  &:not(:first-child) {
    margin-top: 14px;
  }

  > * {
    display: flex;
    align-items: center;
  }

  .circle {
    height: 20px;
    width: 20px;
    border-radius: 50%;
    border: 3px solid;
  }

  .label {
    margin-right: 6px;
    cursor: pointer;
  }

  @media (max-width: 1700px) {
    font-size: 14px;
  }
}
</style>
